<template>
  <v-card
    class="py-5 px-4"
    dark
    color="white"
    text-xs-center
  >
    <v-layout
      row
      wrap
      style="align-items: center"
      class="justify-center contacts-sent-txt"
    >
      <v-flex
        xs1
        style="align-items: center"
      >
        <v-icon
          medium
          color="#FF5146"
        >
          $vuetify.icons.exclamationCircleIcon
        </v-icon>
      </v-flex>
      <v-flex
        xs11
        style="align-items: center"
      >
        <h3 class="title">
          {{ title }}
        </h3>
      </v-flex>
      <v-layout
        row
        wrap
        style="align-items: center"
      >
        <v-flex
          xs1
          style="align-items: top !important"
        />
        <v-flex xs11>
          <div class="description">
            <slot />
          </div>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  props: {
    title: String,
  },
};
</script>

<style scoped>
.title {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #FF5146;
}
.description {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #433D4E;
}
</style>
